import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchBrands = (params = {}) => api.get("/brands", { params }).then((r) => r.data);
export const fetchRegions = () => api.get("/regions").then((r) => r.data);
export const fetchStatistics = () => api.get("/statistics").then((r) => r.data);
export const fetchSettings = () => api.get("/settings").then((r) => r.data);

// Resolve backend-served media paths (e.g. "/api/media/x.jpg") to absolute URLs.
export const mediaUrl = (path) => (path && path.startsWith("/api/") ? `${BACKEND_URL}${path}` : path);

// ---------------- Admin ----------------
export const TOKEN_KEY = "hcc_admin_token";

export const adminApi = axios.create({ baseURL: `${BACKEND_URL}/api` });

adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== "/admin/login") window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);
